// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAjI_001q3VK00yw2CcG8eX4pQNoZHcLEs",
  authDomain: "encuesta-stream.firebaseapp.com",
  projectId: "encuesta-stream",
  storageBucket: "encuesta-stream.appspot.com",
  messagingSenderId: "506533830028",
  appId: "1:506533830028:web:c2a3b957a304fc70bd0aa9",
  measurementId: "G-08ENYX6NX8"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);